/**
 * Admin panel route tree.
 *
 * Exported as a Fragment rather than a component: React Router's <Routes> only
 * accepts <Route> and <React.Fragment> children, so this is interpolated
 * ({adminRoutes}) rather than rendered (<AdminRoutes />), which would throw.
 * (split from App.tsx, finish-line P4 2026-07-28; JSX verbatim)
 */
import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import AdminRoute from '../components/auth/AdminRoute';
import { AdminLayout } from '../layouts/AdminLayout';
import { PageLoader } from './PageLoader';
import {
  AdminLogin,
  AdminAuthCallback,
  AdminDashboard,
  AdminTenants,
  AdminUsers,
  AdminRevenue,
  AdminCredits,
  AdminHealth,
  AdminLogs,
  AdminMonitoring,
  AdminSupport,
  AdminTeam,
  AdminIntegrations,
  AdminMarketing,
  AdminBrandDNA,
  AdminBusinessHub,
  AdminCalendar,
  AdminEmailMarketing,
  AdminPopups,
  AdminSocialAutomator,
  AdminApiKeys,
} from './lazyRoutes';

export const adminRoutes = (
  <>
        {/* Admin Panel Routes */}
        <Route path="/admin/login" element={
          <Suspense fallback={<PageLoader />}><AdminLogin /></Suspense>
        } />
        <Route path="/admin/auth/callback" element={
          <Suspense fallback={<PageLoader />}><AdminAuthCallback /></Suspense>
        } />
        <Route path="/admin" element={<AdminRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={
              <Suspense fallback={<PageLoader />}><AdminDashboard /></Suspense>
            } />
            <Route path="tenants" element={
              <Suspense fallback={<PageLoader />}><AdminTenants /></Suspense>
            } />
            <Route path="calendar" element={
              <Suspense fallback={<PageLoader />}><AdminCalendar /></Suspense>
            } />
            <Route path="support" element={
              <Suspense fallback={<PageLoader />}><AdminSupport /></Suspense>
            } />
            <Route path="logs" element={
              <Suspense fallback={<PageLoader />}><AdminLogs /></Suspense>
            } />
            <Route path="health" element={
              <Suspense fallback={<PageLoader />}><AdminHealth /></Suspense>
            } />
            <Route path="revenue" element={
              <Suspense fallback={<PageLoader />}><AdminRevenue /></Suspense>
            } />
            <Route path="users" element={
              <Suspense fallback={<PageLoader />}><AdminUsers /></Suspense>
            } />
            <Route path="credits" element={
              <Suspense fallback={<PageLoader />}><AdminCredits /></Suspense>
            } />
            <Route path="monitoring" element={
              <Suspense fallback={<PageLoader />}><AdminMonitoring /></Suspense>
            } />
            <Route path="marketing" element={
              <Suspense fallback={<PageLoader />}><AdminMarketing /></Suspense>
            } />
            {/* New super-admin pages — merchant-parity surfaces */}
            <Route path="email-marketing" element={
              <Suspense fallback={<PageLoader />}><AdminEmailMarketing /></Suspense>
            } />
            <Route path="popups" element={
              <Suspense fallback={<PageLoader />}><AdminPopups /></Suspense>
            } />
            <Route path="social-automator" element={
              <Suspense fallback={<PageLoader />}><AdminSocialAutomator /></Suspense>
            } />
            <Route path="business-hub" element={
              <Suspense fallback={<PageLoader />}><AdminBusinessHub /></Suspense>
            } />
            <Route path="brand-dna" element={
              <Suspense fallback={<PageLoader />}><AdminBrandDNA /></Suspense>
            } />
            <Route path="integrations" element={
              <Suspense fallback={<PageLoader />}><AdminIntegrations /></Suspense>
            } />
            <Route path="team" element={
              <Suspense fallback={<PageLoader />}><AdminTeam /></Suspense>
            } />
            <Route path="api-keys" element={
              <Suspense fallback={<PageLoader />}><AdminApiKeys /></Suspense>
            } />
          </Route>
        </Route>  </>
);
